import { useCallback, useEffect, useState } from 'react';
import { useI18n } from '@locales/client';
import { useBanners } from '@/entities/minibanner/model/hooks';
import { useConfirmDataPrompt } from '@/entities/data-confirmation/model/use-confirm-data-prompt';
import { useBreakpoints } from '@/shared/hooks/useBreakpoints';
import { useIsUserLoading, useUserId } from '@/shared/providers/user-provider/use-user';
import { Link } from '@/shared/ui/link';
import {
  BannersWrapper,
  ContentRow,
  ContentRows,
  IconContainer,
  TruncatedText,
} from './styles';
import { BannersSkeleton } from './banners-skeleton';
import { MiniBannerIcon } from './mini-banner-icon';
import { DynamicGameFilter as GameFilter } from '@/widgets/game-filter';
import { brandIsPh } from '@/shared/config/brand-by-target.mjs';
import {
  MiniBannerBadge,
  MiniBannerCounter,
} from '@/entities/minibanner/ui/counters';

const Banners = () => {
  const { isMobile: mobileLandscape } = useBreakpoints();
  const isMobile = Boolean(mobileLandscape);
  const isPhMobile = brandIsPh && isMobile;
  const t = useI18n();
  const { sortedBanners, linkBanners, categoryParam } = useBanners({
    mobileLandscape: Boolean(mobileLandscape),
  });
  const userId = useUserId();
  const isUserLoading = useIsUserLoading();
  const { addQueryParam } = useConfirmDataPrompt();
  const [hasMounted, setHasMounted] = useState(false);
  const isReady = hasMounted && !isUserLoading;
  
  useEffect(() => {
    setHasMounted(true);
  }, []);
  

  const handleClick = useCallback(
    (key, disabled, e) => {
      if (key === 'promocodes' && !userId) {
        e.preventDefault();
        addQueryParam('registration');
        return;
      }

      if (disabled) {
        e.preventDefault();
      }
    },
    [userId, addQueryParam]
  );

  return (
    <BannersWrapper>
      <GameFilter />
      {isReady ? (
        <ContentRows data-section="banners">
          {sortedBanners.map((banner) => (
            <Link
              href={banner.disabled ? '#' : linkBanners(banner.param)}
              key={banner.id}
              passHref
              onClick={(e) => handleClick(banner?.param, banner.disabled, e)}
            >
              <ContentRow
                as="div"
                data-banner-id={banner.id}
              >
                <IconContainer
                  $isActive={categoryParam === banner.param}
                  $isDisabled={banner.disabled}
                >
                  <MiniBannerIcon banner={banner} />
                  <MiniBannerCounter
                    counterKey={banner.counterKey}
                    renderCounter={(count) => (
                      <MiniBannerBadge isPhMobile={isPhMobile} text={count} />
                    )}
                  />
                </IconContainer>
                <TruncatedText>{t(banner.tKey)}</TruncatedText>
              </ContentRow>
            </Link>
          ))}
        </ContentRows>
      ) : (
        <BannersSkeleton />
      )}
    </BannersWrapper>
  );
};

export { Banners };
